module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h1>Importing transactions</h1>\n<ul class="messages">\n  <li class="warning">\n    You are about to import all transactions without a specified account\n    into '+
((__t=( costcentreName ))==null?'':_.escape(__t))+
', are you sure you want to continue?\n  </li>\n</ul>\n<a class="button saveButton">Import</a>\n<a class="button button-secondary closeButton">Cancel</a>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/import_confirmation_dialog.html
// module id = 214
// module chunks = 0